import { Suspense } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';
import { PageLoader } from '@/components/common/PageLoader';
import { DonationAccountsPage } from '@/features/marketPromotion/pages/DonationAccountsPage';
import { donationBatchSearchSchema } from '@/features/marketPromotion/types/marketPromotionP2.types';

export const Route = createFileRoute('/_auth/market-promotion/accounts-adjust')({
  validateSearch: donationBatchSearchSchema,
  component: () => (
    <ErrorBoundary moduleName="Market Promotion Accounts Adjust">
      <Suspense fallback={<PageLoader />}>
        <DonationAccountsPage />
      </Suspense>
    </ErrorBoundary>
  ),
});
